export default __webpack_public_path__ + "static/media/mc_controls_panel.783047b6.svg";